import { render, staticRenderFns } from "./FacebookAdsOverview.vue?vue&type=template&id=7fc2784a&scoped=true&"
import script from "./FacebookAdsOverview.vue?vue&type=script&lang=js&"
export * from "./FacebookAdsOverview.vue?vue&type=script&lang=js&"
import style0 from "./FacebookAdsOverview.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FacebookAdsOverview.vue?vue&type=style&index=1&id=7fc2784a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc2784a",
  null
  
)

export default component.exports